module.exports = __webpack_public_path__ + "img/download-btn-hover.d4d04fad.png";